import React from 'react';
// ---- external imports ----

import { LoadingCursor } from '~/containers/GameAsset/cursors';
// ---- internal imports ----

import AuthBackdrop from '~/authentication/AuthBackdrop';
import { useUserContext } from '~/authentication/UserProvider';
// ---- local imports ----

/**
 * Interstitial shown while no auth screen is mounted yet and the session is still
 * being resolved. The cursor follows the provider's `isAuthBusy`, so it only
 * appears when a request is actually in flight — a visitor with no session gets
 * the plain backdrop instead of a cursor that flashes for a frame.
 *
 * Screens that own their request (and so already know they are busy) say so with
 * `isBusy` rather than waiting for the provider to pick the flow up.
 */
function AuthLoadingScreen({ isBusy }) {
	const user = useUserContext();

	const shouldShowLoadingCursor = isBusy ?? !!user?.isAuthBusy;

	return (
		<AuthBackdrop>
			{shouldShowLoadingCursor && <LoadingCursor />}
		</AuthBackdrop>
	);
}

export default AuthLoadingScreen;
